import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { RightArrow, WarningIcon } from "../../assets/images";
import { TimePicker } from "@mui/x-date-pickers";
import {
  convertMsToHourMinSec,
  returnInputFieldLength,
  reverseDate,
} from "../../utils/commonFunctions";
import Select from "react-select";
import { components } from "react-select";
import { CircularAvatar } from "../commons";
import { DropDownType } from "../../screens/MasterData/HolidayCalender/AddEditHolidayCalender";
import { Button } from "react-bootstrap";
import moment from "moment";
import { AddRegularizePayloadType } from "../../commonTypes/timeSheetTypes";

type AppProps = {
  toggle: () => void;
  handleSubmit: (data: AddRegularizePayloadType) => void;
  data: any;
  isOpen: boolean;
  finalManagerList: any[] | [];
  setManagerOffset: React.Dispatch<React.SetStateAction<number>>;
  setManagerText: React.Dispatch<React.SetStateAction<string>>;
  managerFetching: boolean;
  managerLimit: number;
};

const RegularizeModal = ({
  toggle,
  data,
  isOpen,
  finalManagerList,
  setManagerText,
  setManagerOffset,
  managerFetching,
  managerLimit,
  handleSubmit,
}: AppProps) => {
  const [endTime, setEndTime] = useState<string | null>(null);
  const [startTime, setStartTime] = useState<string | null>(null);
  const [timeDifference, setTimeDifference] = useState<string>("0.00");
  const [regularizeReson, setRegularizeReson] = useState<string>("");
  const [selectManager, setSelectManager] = useState<DropDownType>({
    value: null,
    label: "Select",
  });

  // Compare the times
  const isBefore = moment(startTime, "hh:mm A").isBefore(
    moment(data?.start_time, "hh:mm A")
  );
  const isAfter = moment(endTime, "hh:mm A").isAfter(
    moment(data?.end_time, "hh:mm A")
  );

  useEffect(() => {
    let diff =
      new Date(endTime || data?.end_time).getTime() -
      new Date(startTime || data?.start_time).getTime();
    let convertedDate = convertMsToHourMinSec(diff);
    let splitedDate = convertedDate?.split(":");
    let hour = splitedDate[0];
    let min = +splitedDate[1];

    if (+hour > 0) {
      min += +hour * 60;
    }
    if (+hour == 0 && +min == 0) {
      setTimeDifference("0.00");
    } else {
      let percentageTime = +(+min / 60);
      let finalTime = percentageTime?.toFixed(4)?.toString();
      setTimeDifference(finalTime);
    }
  }, [startTime, endTime]);

  const checkManagerBottom = () => {
    setManagerOffset((prv: any) => prv + managerLimit);
  };

  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label.split("%")[0]}
            image={data?.image && data?.image}
          />
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };

  const handleSelectManager = (data: any) => {
    if (data?.value) {
      setSelectManager(data);
    }
  };

  const handleSubmitData = () => {
    const finalData = {
      date: data?.date ? reverseDate(data?.date) : null,
      manager: selectManager?.value ? selectManager?.value : null,
      startTime: startTime ? moment(startTime).format("hh:mmA") : null,
      endTime: endTime ? moment(endTime).format("hh:mmA") : null,
      comment: regularizeReson,
    };
    handleSubmit(finalData);
  };

  return (
    <Modal
      centered
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      style={{
        maxWidth: "500px",
        width: "100%",
      }}
      backdrop="static"
    >
      <ModalHeader
        className="pt-3 pl-4 pb-3"
        id="cross-cut"
        toggle={toggle}
        style={{
          maxWidth: "500px",
          width: "100%",
        }}
      >
        Attendance Time Update Request
      </ModalHeader>
      <ModalBody style={{ padding: "1rem 0 1rem 0", overflowY: "auto" }}>
        <div
          style={{
            border: "1px solid #BFCBE1",
            margin: "5px 28px",
            borderRadius: "3px",
            padding: "8px 0px",
            backgroundColor: "#F4F6F8",
          }}
        >
          <div className="ml-3 mb-2">
            <span style={{ fontSize: "16px", fontWeight: "500" }}>
              Previous Start And End Time
            </span>
          </div>
          <div className="ml-3 col-md-11" style={{ paddingLeft: "0" }}>
            <table className="thead-light" style={{ width: "100%" }}>
              {
                <thead
                  className="text-start"
                  style={{ backgroundColor: "white" }}
                >
                  <tr
                    className="text-nowrap"
                    style={{
                      color: "#6e7491",
                      fontSize: "14px",
                      backgroundColor: "#F4F6F8",
                    }}
                  >
                    <td>Start Time</td>
                    <td></td>
                    <td>End Time</td>
                    <td>Total Hours</td>
                  </tr>
                </thead>
              }
              <tbody>
                <>
                  {
                    <tr>
                      <td
                        className="pb-2"
                        style={{
                          color: "#262a44",
                          fontWeight: "400",
                          fontSize: "15px",
                        }}
                      >
                        {
                          data?.start_time
                            ?.split(/([0-9]+:[0-9]+)([APMapm]{2})/)
                            ?.filter(Boolean)[0]
                        }{" "}
                        {data?.start_time
                          ?.split(/([0-9]+:[0-9]+)([APMapm]{2})/)
                          .filter(Boolean)[1]
                          .toUpperCase()}
                      </td>
                      <td className="pb-2 pr-4" style={{ width: "5%" }}>
                        <span>
                          <img src={RightArrow} />
                        </span>
                      </td>
                      <td
                        className="pb-2"
                        style={{
                          color: "#262a44",
                          fontWeight: "400",
                          fontSize: "15px",
                        }}
                      >
                        {
                          data?.end_time
                            ?.split(/([0-9]+:[0-9]+)([APMapm]{2})/)
                            ?.filter(Boolean)[0]
                        }{" "}
                        {data?.end_time
                          ?.split(/([0-9]+:[0-9]+)([APMapm]{2})/)
                          .filter(Boolean)[1]
                          .toUpperCase()}
                      </td>
                      <td
                        className="pb-2"
                        style={{
                          color: "#262a44",
                          fontWeight: "400",
                          fontSize: "15px",
                        }}
                      >
                        {!!data?.total_hours
                          ? data?.total_hours?.toFixed(2)
                          : "0.00"}
                      </td>
                    </tr>
                  }
                </>
              </tbody>
            </table>
          </div>
        </div>
        <div style={{ paddingLeft: "12px" }}>
          <div className="ml-3 mt-3">
            <span
              className="ml-3"
              style={{ fontSize: "16px", fontWeight: "500" }}
            >
              New Start And End Time
            </span>
          </div>
          <div
            className="ml-3 mt-2"
            style={{ paddingLeft: "16px", width: "90%" }}
          >
            <span
              style={{
                fontSize: "14px",
                fontWeight: "500",
                color: "#6e7491",
              }}
            >
              Note : New start time must be earlier and new end time later than
              the previous; you can request up to 3 times per month.
            </span>
          </div>
          <div
            className="d-flex justify-content-start align-items-center p-1 mb-4 mt-3"
            style={{
              backgroundColor: "#fff5e5",
              border: "1px solid #be7e12",
              width: "88%",
              borderRadius: "6px",
              marginLeft: "30px",
            }}
          >
            <img src={WarningIcon} alt="warning" />
            <span style={{ color: "#be7e12" }} className="ml-2">
              Only {3 - data?.currentMonthApproveData} time attendance change
              requests left this month.
            </span>
          </div>
          <div className="d-flex mt-3 ml-3 col-md-10">
            <div className="mb-3  mr-2">
              <div className="">
                <div></div>
                <TimePicker
                  label="Start Time"
                  value={startTime}
                  sx={{
                    label: { zIndex: 0 },
                  }}
                  onChange={(date: any) => setStartTime(date)}
                />
              </div>
            </div>
            <div className="mb-3 ">
              <div className="">
                <div></div>
                <TimePicker
                  label="End Time"
                  value={endTime}
                  sx={{
                    label: { zIndex: 0 },
                  }}
                  onChange={(date: any) => setEndTime(date)}
                />
              </div>
            </div>

            <div
              className="ml-2"
              style={{ fontSize: "17px", marginTop: "17px" }}
            >
              {timeDifference ? parseFloat(timeDifference)?.toFixed(2) : 0}
            </div>
          </div>

          <div className="ml-3 col-md-10">
            <label>
              Select Manager<span className="text-danger">*</span>
            </label>
            <Select
              options={finalManagerList}
              value={selectManager}
              components={{ Option }}
              onChange={(e) => handleSelectManager(e)}
              isSearchable={true}
              isLoading={managerFetching}
              onMenuClose={() => {
                setManagerOffset(0);
              }}
              onMenuScrollToBottom={checkManagerBottom}
              onInputChange={(e) => {
                setManagerText(e);
              }}
            />
          </div>

          <div className="ml-3 mt-3 col-md-10">
            <label>
              Reason<span className="text-danger">*</span>
            </label>
            <div>
              <textarea
                className="form-control"
                style={{ width: "100%" }}
                onChange={(e) => setRegularizeReson(e.target.value)}
                value={regularizeReson}
                maxLength={250}
              />
              <p className="text-right mt-1" style={{ fontSize: "11px" }}>
                {returnInputFieldLength(regularizeReson.length, 250)}
              </p>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <span
          className="pointer btn"
          onClick={() => {
            toggle();
          }}
          style={{ border: "1px solid #bfcbe1", marginRight: "15px" }}
        >
          Cancel
        </span>
        <Button
          color="primary ml-3"
          onClick={() => {
            handleSubmitData();
            toggle();
          }}
          disabled={
            !selectManager?.value ||
            !regularizeReson?.trim()?.length ||
            (!endTime && !startTime) ||
            (!!startTime && !isBefore) ||
            (!!endTime && !isAfter)
          }
        >
          Submit
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default RegularizeModal;
